/**
 * Uzbek strings of the client card and the inbox's filters and payment link (Wave 1). Spread into
 * `uz`, so a key here is a `TranslationKey` like any other.
 */
export const uzClientInboxW1 = {
  // ---------------------------------------------------------------- the card's AI switch
  "clientCardW1.ai.label": "AI javob bermasin",
  "clientCardW1.ai.on": "AI javob bermaydi",
  "clientCardW1.ai.failed": "Sozlamani saqlab bo'lmadi.",

  // ---------------------------------------------------------------- channels
  "clientCardW1.identity.primary": "Asosiy",

  // ---------------------------------------------------------------- portrait
  "clientCardW1.portrait.title": "Portret",
  "clientCardW1.portrait.error": "Portretni yuklab bo'lmadi.",
  "clientCardW1.portrait.children": "Bolalar yoshi",
  "clientCardW1.portrait.budget": "Byudjet",
  "clientCardW1.portrait.perPerson": "bir kishiga",
  "clientCardW1.portrait.styles": "Sayohat uslubi",
  "clientCardW1.portrait.liked": "Yoqqan mehmonxonalar",
  "clientCardW1.portrait.disliked": "Yoqmagan mehmonxonalar",
  "clientCardW1.portrait.previous": "Oldingi yo'nalishlar",
  "clientCardW1.portrait.contactNote": "Aloqa izohi",
  "clientCardW1.portrait.passport": "Pasport holati",
  "clientCardW1.portrait.note": "Izoh",
  "clientCardW1.portrait.aiExtracted": "AI ajratdi, tasdiqlanmagan",
  "clientCardW1.portrait.aiSuggested": "AI taklif qildi: {value}",
  "clientCardW1.portrait.confirm": "Tasdiqlash",
  "clientCardW1.portrait.dismiss": "Rad etish",
  "clientCardW1.portrait.decideFailed": "Qarorni saqlab bo'lmadi.",

  // ---------------------------------------------------------------- payments
  "clientCardW1.payments.tab": "To'lovlar",
  "clientCardW1.payments.label": "Mijozning to'lovlari",
  "clientCardW1.payments.error": "To'lovlarni yuklab bo'lmadi",
  "clientCardW1.payments.retry": "Qayta urinish",
  "clientCardW1.payments.empty": "To'lov yo'q",
  "clientCardW1.payments.denied": "Bu bo'limga ruxsatingiz yo'q",
  "clientCardW1.payments.ownOnly": "Faqat o'z bitimlaringizdagi to'lovlar ko'rinadi.",
  "clientCardW1.payments.date": "Sana",
  "clientCardW1.payments.deal": "Bitim",
  "clientCardW1.payments.amount": "Summa",
  "clientCardW1.payments.account": "Kassa / usul",
  "clientCardW1.payments.status": "Holat",

  // ---------------------------------------------------------------- inbox filters
  "inboxFilter.account": "Akkaunt",
  "inboxFilter.allAccounts": "Barcha akkauntlar",
  "inboxFilter.branch": "Filial",
  "inboxFilter.allBranches": "Barcha filiallar",
  "inboxFilter.mode": "Rejim",
  "inboxFilter.allModes": "Barcha rejimlar",
  "inboxFilter.mode.ai": "AI javob beradi",
  "inboxFilter.mode.ai_draft": "AI qoralama yozadi",
  "inboxFilter.mode.human": "Operator javob beradi",
  "inboxFilter.more": "Filtrlar",
  "inboxFilter.handoff": "AI topshirgan",
  "inboxFilter.reset": "Tozalash",

  // ---------------------------------------------------------------- read-only thread
  "threadRead.notice": "Bu suhbat {name} zimmasida. Siz uni faqat o'qiy olasiz.",

  // ---------------------------------------------------------------- payment link in the thread
  "threadLink.action": "To'lov havolasini yuborish",
  "threadLink.noDeal": "Havola bitimga yoziladi. Avval «Bitim yaratish» tugmasini bosing.",
  "threadLink.summaryFailed": "Bitim qoldig'ini o'qib bo'lmadi.",
  "threadLink.message": "To'lov havolasi: {amount} · {gateway}\n{url}",
  "threadLink.queued": "Havola navbatga qo'yildi.",
  "paymentLink.resend": "Qayta yuborish",
  "paymentLink.sending": "Havola suhbatga yuborilmoqda.",
} as const;
